/**
 * 戻るボタン
 */

export function backButton(dataAttribute) {
	// data-attribute を持つ要素を取得
	const backButton = document.querySelector(`[${dataAttribute}]`);

	// 戻るボタンが存在する場合にクリックイベントを設定
	if (backButton) {
		backButton.addEventListener('click', () => {
			window.history.back();
		});
	}
}
